function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.65 52.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M33.17,52.84H13.49a8.37,8.37,0,0,1-8.43-8.22L4.29,10.1l4-.08.76,34.5a4.41,4.41,0,0,0,4.44,4.32H33.17a4.41,4.41,0,0,0,4.43-4.32L38.36,10l4,.08L41.6,44.61A8.39,8.39,0,0,1,33.17,52.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M44.65,11.3H2a2,2,0,0,1,0-4H44.65a2,2,0,0,1,0,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M32.33,11.3h-18v-2A9.31,9.31,0,0,1,23.63,0a8.71,8.71,0,0,1,8.7,8.7Zm-13.61-4h9.39A4.7,4.7,0,0,0,23.63,4,5.31,5.31,0,0,0,18.72,7.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M33.75,15.21V44a2,2,0,0,1-4,0V15.21a2,2,0,0,1,4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M25.33,15.21V44a2,2,0,0,1-4,0V15.21a2,2,0,0,1,4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M16.91,15.21V44a2,2,0,0,1-4,0V15.21a2,2,0,0,1,4,0Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.bacd6a55.svg";
export { ForwardRef as ReactComponent };